<template>
    <div>

        <config-main-title>
            Motivo de {{ exibir_local }}
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="form-row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Motivo
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum motivo identificado.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <big data-toggle="tooltip" data-placement="top" title="Teto para data futura" 
                            v-if="dado.dt_inicio_vigencia > $util.hoje()">
                            <i class="fas fa-plane-departure mr-2"></i>
                        </big>
                        <big data-toggle="tooltip" data-placement="top" title="Teto com vigência já passada" 
                            v-if="dado.dt_final_vigencia < $util.hoje()">
                            <i class="fas fa-history mr-2"></i>
                        </big>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else-if="dado.operadora">
                            <span class="badge badge-success">{{ dado.operadora.search }}</span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_motivo_glosa ? '' : 'Novo' }}
                            Motivo de 
                            {{ exibir_local }}
                            {{ item && item.id_motivo_glosa ? '#' + item.id_motivo_glosa : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_descricao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Grupo"
                                    type="select"
                                    optionsMode="aql"
                                    service="grupo_motivo_glosas.index"
                                    optionsData="id_grupo_motivo_glosa"
                                    optionsDisplay="st_grupo_motivo_glosa"
                                    :validate="validate"
                                    required
                                    v-model="item.id_grupo_motivo_glosa" />
                            </div>
                        </div>

                        <template v-if="!item.fl_interno">
                            <div class="row" v-if="!item.fl_interno">
                                <div class="col col-12">
                                    <az-input
                                        label="Código"
                                        type="number"
                                        :validate="validate"
                                        required
                                        v-model="item.in_codigo" />
                                </div>
                            </div>

                            <p class="alert alert-info mt-3">Se o motivo for específico de uma operadora, informe-a no campo abaixo.</p>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Operadora"
                                        placeholder="Todas"
                                        type="select"
                                        optionsMode="aql"
                                        service="operadoras.index"
                                        optionsData="id_operadora"
                                        optionsDisplay="search"
                                        :validate="validate"
                                        v-model="item.id_operadora" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="motivoGlosa" :id="item.id_motivo_glosa" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_motivo_glosa ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['local'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton
    },

    computed: { 
        exibir_local: function () { 
            if ( this.local == 'interno' ) { 
                return 'Pendência de Guia';
            } else { 
                return 'Glosa de Operadora';
            }
        },

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        
        incluir () { 
            this.validate = false;

            let item = {
                id_motivo_glosa: null, 
                st_descricao: "", 
                in_codigo: 0, 
                fl_ativo: true,
                fl_interno: this.local == 'interno',
                id_operadora: "", 
                id_grupo_motivo_glosa: "",  
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'motivos_glosa',
                func: 'index',
                parms: { 
                    local: this.local, 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'motivos_glosa',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'motivos_glosa',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Motivo de " + this.exibir_local, method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>